"use strict";

exports.__esModule = true;
exports.TimeSeriesScatterChart = void 0;
var _react = _interopRequireDefault(require("react"));
var _recharts = require("recharts");
var _yAxis = require("../Axes/YAxis/yAxis");
var _XAxis = require("../Axes/XAxis");
var _TooltipContent = require("../Tooltip/TooltipContent");
var _constants = require("../constants");
var _styledComponents = require("styled-components");
var _legendStyle = require("../legendStyle");
var _modernChartLayout = require("../modernChartLayout");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var TimeSeriesScatterChart = exports.TimeSeriesScatterChart = function TimeSeriesScatterChart(props) {
  var width = props.width,
    height = props.height,
    _props$showChartToolt = props.showChartTooltip,
    showChartTooltip = _props$showChartToolt === void 0 ? true : _props$showChartToolt,
    _props$showLegend = props.showLegend,
    showLegend = _props$showLegend === void 0 ? true : _props$showLegend,
    _props$showGrid = props.showGrid,
    showGrid = _props$showGrid === void 0 ? true : _props$showGrid,
    _props$data = props.data,
    timeSeriesData = _props$data === void 0 ? [] : _props$data,
    _props$scatterPlotRad = props.scatterPlotRadius,
    scatterPlotRadius = _props$scatterPlotRad === void 0 ? 5 : _props$scatterPlotRad,
    _props$tooltipProps = props.tooltipProps,
    tooltipProps = _props$tooltipProps === void 0 ? {} : _props$tooltipProps,
    _props$legendProps = props.legendProps,
    legendProps = _props$legendProps === void 0 ? {} : _props$legendProps,
    _props$xAxisProps = props.xAxisProps,
    xAxisProps = _props$xAxisProps === void 0 ? {} : _props$xAxisProps,
    _props$yAxisProps = props.yAxisProps,
    yAxisProps = _props$yAxisProps === void 0 ? {} : _props$yAxisProps;
  var theme = _react["default"].useContext(_styledComponents.ThemeContext);
  return /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "scatter-chart-test-id"
  }, /*#__PURE__*/_react["default"].createElement(_recharts.ScatterChart, _extends({
    width: width,
    height: height
  }, (0, _modernChartLayout.modernChartProps)(theme)), showGrid && (theme.uiModern ? /*#__PURE__*/_react["default"].createElement(_recharts.CartesianGrid, {
    vertical: false,
    stroke: theme.ChartGridColor
  }) : /*#__PURE__*/_react["default"].createElement(_recharts.CartesianGrid, {
    strokeDasharray: "3 3"
  })), (0, _yAxis.yAxis)(Object.assign({}, yAxisProps, {
    theme: theme
  })), (0, _XAxis.timeSeriesAxis)(Object.assign({}, xAxisProps, {
    theme: theme
  })), /*#__PURE__*/_react["default"].createElement(_recharts.ZAxis, {
    range: [scatterPlotRadius * 15]
  }), showChartTooltip && /*#__PURE__*/_react["default"].createElement(_recharts.Tooltip, {
    cursor: theme.uiModern ? {
      stroke: theme.ToolTipHandleColor,
      strokeWidth: 1
    } : true,
    content: /*#__PURE__*/_react["default"].createElement(_TooltipContent.TooltipContent, {
      chartType: _constants.SCATTER_CHART,
      xValueFormatter: tooltipProps.xValueFormatter,
      yValueFormatter: tooltipProps.yValueFormatter
    })
  }), timeSeriesData.map(function (itemData) {
    return /*#__PURE__*/_react["default"].createElement(_recharts.Scatter, {
      className: "scatter-" + itemData.name,
      key: itemData.name,
      name: itemData.name,
      data: itemData.data,
      fill: itemData.color,
      dataKey: "value"
    });
  }), showLegend && /*#__PURE__*/_react["default"].createElement(_recharts.Legend, _extends({}, (0, _legendStyle.legendStyle)(theme, {
    iconType: "circle",
    iconSize: 9
  }), legendProps, {
    wrapperStyle: {
      fontSize: (0, _legendStyle.legendFontSize)(theme)
    }
  }))));
};